import { render } from "./wf-qlc.vue?vue&type=template&id=6364a10e&scoped=true"
import script from "./wf-qlc.vue?vue&type=script&lang=js"
export * from "./wf-qlc.vue?vue&type=script&lang=js"

import "./wf-qlc.vue?vue&type=style&index=0&id=6364a10e&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6364a10e"]])

export default __exports__